import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectMarkAsReadOption')(function selectMarkAsReadOption(choice, state) {
    var optionState = state.optionState;
    optionState.behavior = choice === 'Instant' ? 'Delayed' : choice;
    // TODO: VSO:13206 - Implement a customizable delay
    optionState.delay = choice === 'Instant' ? 0 : 5;
}));
//# sourceMappingURL=selectMarkAsReadOption.js.map